import React from 'react';
import { Navigate } from 'react-router-dom';

class Logout extends React.Component {
    constructor(props) {
        super(props);
        localStorage.removeItem('luxtrip-user');
        if(Object.keys(props.user).length){
            props.setUser({})
        }
    }
    componentDidMount(){
        // window.location.reload()
    }
    
    render() {
        return <Navigate to="/"/>           
          
    }
}
export default Logout;